import React from "react";
import theme from "../../configs/theme";

const IconColorCanteen = (props) => {
  const color = props.color ? props.color : theme.palette.primary.main;
  return (
    <>
      <svg version="1.1" viewBox="0 0 51 51" width="22" height="@2">
        <g id="Mask_Group_45">
          <g id="Group_2557" transform="translate(-2.276 1.688)">
            <g id="Group_2556" transform="translate(0 1)">
              <rect
                id="Rectangle_5763"
                x="2.3"
                y="-2.7"
                fill="#E3ECEB"
                width="51"
                height="51"
              />
              <path
                id="Rectangle_5765"
                fill="#C6D3D4"
                d="M8.3,26.1h26.5c1.9,0,3.5,1.5,3.5,3.5v13.5c0,1.9-1.5,3.5-3.5,3.5H8.3
				c-1.9,0-3.5-1.5-3.5-3.5V29.6C4.8,27.7,6.4,26.1,8.3,26.1z"
              />
              <path
                id="Path_9949"
                fill="#E7EBEA"
                d="M36.7,45.7V29.6c0-1.4-1.1-2.5-2.5-2.5l0,0H8.9c-1.4,0-2.5,1.1-2.5,2.5l0,0v16.1H36.7z"
              />
              <g id="Group_2537" transform="translate(13.181 29.64)">
                <path
                  id="Path_9950"
                  fill="#FFFFFF"
                  d="M3.2,1.8v0.3c0,0.1,0,0.2-0.1,0.3C3,2.6,2.8,2.7,2.6,2.7h-7.2c-0.2,0-0.5-0.1-0.6-0.3
					c-0.1-0.1-0.1-0.2-0.1-0.3V1.8H3.2z"
                />
                <path
                  id="Path_9951"
                  fill="#F3F4F3"
                  d="M3.1,2.4C3,2.6,2.8,2.7,2.6,2.7h-7.2c-0.2,0-0.5-0.1-0.6-0.3H3.1z"
                />
              </g>
              <g id="Group_2538" transform="translate(13.181 30.606)">
                <path
                  id="Path_9952"
                  fill="#FFFFFF"
                  d="M3.2,1.9v0.3c0,0.1,0,0.2-0.1,0.3C3,2.8,2.8,2.9,2.6,2.9h-7.2c-0.2,0-0.5-0.1-0.6-0.3
					c-0.1-0.1-0.1-0.2-0.1-0.3V1.9H3.2z"
                />
                <path
                  id="Path_9953"
                  fill="#F3F4F3"
                  d="M3.1,2.6C3,2.8,2.8,2.9,2.6,2.9h-7.2c-0.2,0-0.5-0.1-0.6-0.3H3.1z"
                />
              </g>
              <g id="Group_2539" transform="translate(13.181 31.466)">
                <path
                  id="Path_9954"
                  fill="#FFFFFF"
                  d="M3.2,2.1v0.3c0,0.1,0,0.2-0.1,0.3C3,2.9,2.8,3,2.6,3h-7.2c-0.2,0-0.5-0.1-0.6-0.3
					c-0.1-0.1-0.1-0.2-0.1-0.3V2.1H3.2z"
                />
                <path
                  id="Path_9955"
                  fill="#F3F4F3"
                  d="M3.1,2.7C3,2.9,2.8,3,2.6,3h-7.2c-0.2,0-0.5-0.1-0.6-0.3H3.1z"
                />
              </g>
              <g id="Group_2540" transform="translate(13.181 32.327)">
                <path
                  id="Path_9956"
                  fill="#FFFFFF"
                  d="M3.2,2.2v0.3c0,0.1,0,0.2-0.1,0.3C3,3,2.8,3.1,2.6,3.1h-7.2c-0.2,0-0.5-0.1-0.6-0.3
					c-0.1-0.1-0.1-0.2-0.1-0.3V2.2H3.2z"
                />
                <path
                  id="Path_9957"
                  fill="#F3F4F3"
                  d="M3.1,2.8C3,3,2.8,3.1,2.6,3.1h-7.2c-0.2,0-0.5-0.1-0.6-0.3H3.1z"
                />
              </g>
              <g id="Group_2541" transform="translate(28.608 37.852)">
                <path
                  id="Path_9958"
                  fill="#FFFFFF"
                  d="M5.6,3v0.3c0,0.1,0,0.2-0.1,0.3C5.4,3.9,5.2,4,4.9,4h-7.2c-0.2,0-0.5-0.1-0.6-0.3
					c-0.1-0.1-0.1-0.2-0.1-0.3V3H5.6z"
                />
                <path
                  id="Path_9959"
                  fill="#F3F4F3"
                  d="M5.5,3.7C5.4,3.9,5.2,4,4.9,4h-7.2c-0.2,0-0.5-0.1-0.6-0.3H5.5z"
                />
              </g>
              <g id="Group_2542" transform="translate(28.608 38.817)">
                <path
                  id="Path_9960"
                  fill="#FFFFFF"
                  d="M5.6,3.2v0.3c0,0.1,0,0.2-0.1,0.3C5.4,4,5.2,4.1,4.9,4.1h-7.2c-0.2,0-0.5-0.1-0.6-0.3
					c-0.1-0.1-0.1-0.2-0.1-0.3V3.2H5.6z"
                />
                <path
                  id="Path_9961"
                  fill="#F3F4F3"
                  d="M5.5,3.8C5.4,4,5.2,4.1,4.9,4.1h-7.2c-0.2,0-0.5-0.1-0.6-0.3H5.5z"
                />
              </g>
              <g id="Group_2543" transform="translate(28.608 39.678)">
                <path
                  id="Path_9962"
                  fill="#FFFFFF"
                  d="M5.6,3.3v0.3c0,0.1,0,0.2-0.1,0.3C5.4,4.1,5.2,4.3,4.9,4.3h-7.2c-0.2,0-0.5-0.1-0.6-0.3
					c-0.1-0.1-0.1-0.2-0.1-0.3V3.3H5.6z"
                />
                <path
                  id="Path_9963"
                  fill="#F3F4F3"
                  d="M5.5,3.9C5.4,4.1,5.2,4.3,4.9,4.3h-7.2c-0.2,0-0.5-0.1-0.6-0.3H5.5z"
                />
              </g>
              <g id="Group_2544" transform="translate(28.608 40.538)">
                <path
                  id="Path_9964"
                  fill="#FFFFFF"
                  d="M5.6,3.5v0.3c0,0.1,0,0.2-0.1,0.3C5.4,4.3,5.2,4.4,4.9,4.4h-7.2c-0.2,0-0.5-0.1-0.6-0.3
					C-2.9,4-2.9,3.9-2.9,3.7V3.5H5.6z"
                />
                <path
                  id="Path_9965"
                  fill="#F3F4F3"
                  d="M5.5,4.1C5.4,4.3,5.2,4.4,4.9,4.4h-7.2c-0.2,0-0.5-0.1-0.6-0.3H5.5z"
                />
              </g>
              <path id="Path_9966" fill="#F3F4F3" d="M19.4,35.5" />
              <path
                id="Path_9967"
                fill="#C35A4D"
                d="M19.4,31.9L19.4,31.9L19.4,31.9L19.4,31.9z"
              />
              <path
                id="Path_9968"
                fill="#C35A4D"
                d="M19.4,31.9L19.4,31.9L19.4,31.9L19.4,31.9z"
              />
              <g id="Group_2545" transform="translate(22.234 29.43)">
                <path
                  id="Path_9969"
                  fill="#C35A4D"
                  d="M-1.8,5.8C-1.8,5.9-1.9,6-2,6c0,0,0,0,0,0h-1.6c-0.1,0-0.2-0.1-0.2-0.3c0,0,0,0,0,0l0.6-3.3
					h0.8L-1.8,5.8z"
                />
                <path
                  id="Path_9970"
                  fill="#C9706D"
                  d="M-2.5,2.4l-0.3,0h0l-0.3,0l0.3-0.7h0.1L-2.5,2.4z"
                />
                <path
                  id="Rectangle_5766"
                  fill="#C35A4D"
                  d="M-3.4,2.4h1.1c0,0,0.1,0,0.1,0.1v0c0,0,0,0.1-0.1,0.1h-1.1C-3.4,2.5-3.4,2.5-3.4,2.4
					L-3.4,2.4C-3.4,2.4-3.4,2.4-3.4,2.4z"
                />
              </g>
              <g id="Group_2546" transform="translate(23.637 29.43)">
                <path
                  id="Path_9971"
                  fill="#EFD650"
                  d="M-1.6,5.8C-1.6,5.9-1.7,6-1.8,6c0,0,0,0,0,0h-1.6c-0.1,0-0.2-0.1-0.2-0.3c0,0,0,0,0,0
					L-3,2.5h0.8L-1.6,5.8z"
                />
                <path
                  id="Path_9972"
                  fill="#EFD650"
                  d="M-2.3,2.4l-0.3,0h0l-0.3,0l0.3-0.7h0.1L-2.3,2.4z"
                />
                <path
                  id="Rectangle_5767"
                  fill="#E6C935"
                  d="M-3.2,2.4h1.1c0,0,0.1,0,0.1,0.1v0c0,0,0,0.1-0.1,0.1h-1.1C-3.2,2.5-3.2,2.5-3.2,2.4
					L-3.2,2.4C-3.2,2.4-3.2,2.4-3.2,2.4z"
                />
              </g>
              <g id="Group_2547" transform="translate(25.041 29.43)">
                <path
                  id="Path_9973"
                  fill="#CFCFCF"
                  d="M-1.4,5.8C-1.4,5.9-1.5,6-1.6,6c0,0,0,0,0,0h-1.6c-0.1,0-0.2-0.1-0.2-0.3c0,0,0,0,0,0
					l0.6-3.3H-2L-1.4,5.8z"
                />
                <path
                  id="Path_9974"
                  fill="#CFCFCF"
                  d="M-2.1,2.4l-0.3,0h0l-0.3,0l0.3-0.7h0.1L-2.1,2.4z"
                />
                <path
                  id="Rectangle_5768"
                  fill="#C1C1C1"
                  d="M-2.9,2.4h1.1c0,0,0.1,0,0.1,0.1v0c0,0,0,0.1-0.1,0.1h-1.1C-3,2.5-3,2.5-2.9,2.4
					L-2.9,2.4C-3,2.4-3,2.4-2.9,2.4z"
                />
              </g>
              <g id="Group_2548" transform="translate(28.095 31.132)">
                <path
                  id="Path_9975"
                  fill="#FEFFFF"
                  d="M1.5,2.2c0,0-0.2,1.7-1.1,2.1c-0.3,0.1-0.7,0.1-1,0.1c-0.4,0-0.7,0-1.1-0.1
					c-0.9-0.4-1.1-2.1-1.1-2.1l2.2,0L1.5,2.2z"
                />
                <path
                  id="Path_9976"
                  fill="#D6D7D9"
                  d="M1.7,2.3h-4.6C-2.9,2.3-3,2.2-3,2.1l0,0C-3,2.1-2.9,2-2.9,2h4.6c0.1,0,0.1,0.1,0.1,0.1l0,0
					C1.8,2.2,1.8,2.3,1.7,2.3z"
                />
              </g>
              <g id="Group_2549" transform="translate(32.676 31.132)">
                <path
                  id="Path_9977"
                  fill="#FEFFFF"
                  d="M2.2,2.2c0,0-0.2,1.7-1.1,2.1c-0.3,0.1-0.7,0.1-1,0.1c-0.4,0-0.7,0-1.1-0.1
					c-0.9-0.4-1.1-2.1-1.1-2.1l2.2,0L2.2,2.2z"
                />
                <path
                  id="Path_9978"
                  fill="#D6D7D9"
                  d="M2.4,2.3h-4.6c-0.1,0-0.1-0.1-0.1-0.1l0,0C-2.3,2.1-2.2,2-2.2,2h4.6c0.1,0,0.1,0.1,0.1,0.1
					l0,0C2.5,2.2,2.5,2.3,2.4,2.3z"
                />
              </g>
              <rect
                id="Rectangle_5769"
                x="5.5"
                y="35.4"
                fill="#C6D2D4"
                width="31.8"
                height="1"
              />
              <g id="Group_2550" transform="translate(41.288 21.646)">
                <rect
                  id="Rectangle_5770"
                  x="-1"
                  y="0.6"
                  fill="#C6D3D4"
                  width="14.8"
                  height="14.8"
                />
                <path
                  id="Rectangle_5771"
                  fill="#FFFFFF"
                  d="M1,2.3h10.8c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5H1C0.7,3.2,0.5,3,0.5,2.8
					l0,0C0.5,2.5,0.7,2.3,1,2.3z"
                />
                <path
                  id="Rectangle_5772"
                  fill="#FFFFFF"
                  d="M1,4.5h10.8c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5H1C0.7,5.4,0.5,5.2,0.5,5
					l0,0C0.5,4.7,0.7,4.5,1,4.5z"
                />
                <path
                  id="Rectangle_5773"
                  fill="#FFFFFF"
                  d="M1,6.7h10.8c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5H1
					c-0.3,0-0.5-0.2-0.5-0.5l0,0C0.5,6.9,0.7,6.7,1,6.7z"
                />
                <path
                  id="Rectangle_5774"
                  fill="#FFFFFF"
                  d="M1,8.9h10.8c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5H1
					c-0.3,0-0.5-0.2-0.5-0.5l0,0C0.5,9.1,0.7,8.9,1,8.9z"
                />
                <path
                  id="Rectangle_5775"
                  fill="#FFFFFF"
                  d="M1,11.1h10.8c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5H1
					c-0.3,0-0.5-0.2-0.5-0.5l0,0C0.5,11.3,0.7,11.1,1,11.1z"
                />
                <path
                  id="Rectangle_5776"
                  fill="#FFFFFF"
                  d="M1,13.3h10.8c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5H1
					c-0.3,0-0.5-0.2-0.5-0.5l0,0C0.5,13.5,0.7,13.3,1,13.3z"
                />
              </g>
              <path
                id="Rectangle_5777"
                fill={color}
                d="M3.7,45.5h48.2c0.8,0,1.4,0.6,1.4,1.4l0,0c0,0.8-0.6,1.4-1.4,1.4H3.7
				c-0.8,0-1.4-0.6-1.4-1.4l0,0C2.3,46.1,2.9,45.5,3.7,45.5z"
              />
              <g id="Group_2555" transform="translate(8.397 2.976)">
                <g id="Group_2551" transform="translate(3.12 1.197)">
                  <rect
                    id="Rectangle_5778"
                    x="-1.9"
                    y="-2.1"
                    fill="#F8F9FC"
                    width="0.5"
                    height="5.2"
                  />
                  <path
                    id="Path_9979"
                    fill={color}
                    d="M-5.5,5.6c0.1-2.1,1.8-3.8,4-3.8c2.1,0.1,3.7,1.7,3.8,3.8H-5.5z"
                  />
                </g>
                <g id="Group_2552" transform="translate(19.558 1.197)">
                  <rect
                    id="Rectangle_5779"
                    x="0.6"
                    y="-2.1"
                    fill="#F8F9FC"
                    width="0.5"
                    height="5.2"
                  />
                  <path
                    id="Path_9980"
                    fill={color}
                    d="M-3,5.6c0.1-2.1,1.8-3.8,4-3.8C3,1.8,4.6,3.5,4.7,5.6H-3z"
                  />
                </g>
                <g id="Group_2553" transform="translate(35.995 1.197)">
                  <rect
                    id="Rectangle_5780"
                    x="3.1"
                    y="-2.1"
                    fill="#F8F9FC"
                    width="0.5"
                    height="5.2"
                  />
                  <path
                    id="Path_9981"
                    fill={color}
                    d="M-0.5,5.6c0.1-2.1,1.8-3.8,4-3.8c2.1,0.1,3.7,1.7,3.8,3.8H-0.5z"
                  />
                </g>
                <rect
                  id="Rectangle_5782"
                  x="-6"
                  y="-2.2"
                  fill={color}
                  width="50.8"
                  height="2.8"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </>
  );
};

export default IconColorCanteen;
